import { render, staticRenderFns } from "./transactionTypesCharges.vue?vue&type=template&id=2ac31dae"
import script from "./transactionTypesCharges.vue?vue&type=script&lang=js"
export * from "./transactionTypesCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports